import { createWorkerAction } from '../lib';

export const fitIntoView = createWorkerAction('FIT_INTO_VIEW');
